import { render, staticRenderFns } from "./TipoPasajePage.vue?vue&type=template&id=a67a2086"
import script from "./TipoPasajePage.js?vue&type=script&lang=js&external"
export * from "./TipoPasajePage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports